<mat-form-field appearance="outline" class="w-100" color="primary" subscriptSizing="dynamic">
    <mat-label>{{ title }}</mat-label>
    <input #timelineInput [disabled]="disabled" [formControl]="timelineSearchControl"
           [matAutocomplete]="auto" [matChipInputFor]="chipList"
           [placeholder]="placeholder" [readonly]="disabled" matInput>
    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)='selectUser($event.option.value)'
                      [displayWith]="displayFn">
        @for (timeline of filteredTimelines; track timeline.id) {
            @if (!checkIfInArray(timeline, selectedTimelines)) {
                <mat-option [value]="timeline">
                    {{ nameDisplay(timeline) }}
                </mat-option>
            }
        }
    </mat-autocomplete>
    @if (timelineSearchControl?.value?.id && !disabled) {
        <button (click)="this.timelineSearchControl.setValue(null); this.timelineSelect.emit(undefined);"
                aria-label="Clear Search" mat-icon-button
                matSuffix>
            <mat-icon>close</mat-icon>
        </button>
    }
    @if (loading) {
        <mat-icon matSuffix>
            <mat-spinner color="primary"></mat-spinner>
        </mat-icon>
    }
    @if (timelineSearchControl.value?.length < 2) {
        <mat-hint>A minimum of 2 characters is required to search
        </mat-hint>
    }
</mat-form-field>
<mat-chip-grid #chipList aria-label="Users Selection">
    @for (user of this.selectedTimelines; track user) {
        <mat-chip (removed)="removeUser(user)"
                  class="smChip">
            {{ user| nameDisplay: 'username' }}
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>
    }
</mat-chip-grid>
